<template>
  <div>
    <a role="button" class="btn btn-primary" @click="submit()"><i class="fas fa-save"></i></a>
    <a v-if="!isEnableFilter" role="button" class="btn btn-primary " @click="btnEnableOrDisable()"><i class="fa fa-cog"></i>開啟篩選</a>

    <div v-if="isEnableFilter" >
      <a role="button" class="btn btn-primary " @click="btnEnableOrDisable()"><i class="fa fa-times-circle"></i>關閉篩選</a>
      <a role="button" class="btn btn-primary " @click="btnClear"><i class="fa fa-sync"></i> 清除篩選</a>
      <div class="row" style="width:1300px;margin-top:20px">
        <div class="col-3" v-for="(item,index) in this.GetUniqueGroup1()" :key="index" >
          <a role="button" class="btn btn-primary filterItembutton" @click="FilterByGroup1(item)">{{item}}</a>
        </div>
      </div>


<!--      <div class="row" style="width:800px">-->
<!--        <div class="col-3" v-if="currentFilterGroup1 !==''">-->
<!--          <a role="button" class="btn btn-info abutton" @click="FilterByGroup2()">全部</a>-->
<!--        </div>-->
<!--        <div class="col-3" v-for="(item,index) in this.GetUniqueGroup2(currentFilterGroup1)" :key="index" >-->
<!--          <a role="button" class="btn btn-info abutton" @click="FilterByGroup2(item)">{{item}}</a>-->
<!--        </div>-->
<!--      </div>-->
    </div>

    <hr>

    <a class="btn btn-primary" @click="DataItemMaster_AddLast"><i class="fas fa-plus-circle"></i></a>
    <table class="table table-hover" id="tblMain">
      <thead class="thead-light">
      <tr>
        <th class="text-center">功能</th>
        <th>啟停用</th>
        <th>分類</th>
<!--        <th>Tag</th>-->
        <th>標題</th>
      </tr>
      </thead>
      <tbody>
      <template v-for="(masterItem) in datas.KBItems">
        <tr :key="masterItem.SystemId" v-show="IsShow(masterItem)">
          <td class="text-center" width="280px">
            <a class="btn btn-primary" @click="DataItemMaster_Insert(masterItem)"><i class="fas fa-plus-circle"></i></a>
            <a class="btn btn-danger" @click="DataItemMaster_Remove(masterItem)"><i class="far fa-trash-alt"></i></a>
            <a class="btn btn-primary" @click="DataItemMaster_MoveUp(masterItem)"><i class="fa fa-angle-up"></i> </a>
            <a class="btn btn-primary" @click="DataItemMaster_MoveDown(masterItem)"><i class="fa fa-angle-down"></i> </a>
            <a class="btn btn-primary" v-b-toggle="'collapse-' + masterItem.SystemId" ><i class="fa fa-bars"></i> </a>
          </td>
          <td width="100px" >
            <MyButtonEnableDisable v-model="masterItem.IsEnable"></MyButtonEnableDisable>
          </td>
          <td width="200px">
            <input type="text" class="form-control" placeholder="" v-model="masterItem.Group1">
          </td>
<!--          <td width="200px">-->
<!--            <MyTagInput v-model="masterItem.Tags"  placeholder="請輸入"></MyTagInput>-->
<!--          </td>-->
          <td width="">
            <div class="form-inline">
              <input type="text" class="form-control flex-fill" placeholder="" v-model="masterItem.Text">
<!--              <a role="button" class="btn btn-primary " @click="editHtmlContent(masterItem)"><i class="fa fa-pen"></i></a>-->
            </div>
          </td>

        </tr>

        <tr :key="'tr'+masterItem.SystemId" v-show="IsShow(masterItem)">
          <td colspan="5">
            <b-collapse :id="'collapse-'+masterItem.SystemId" class="mt-2" style="margin-left: 200px">
              <b-card>
                <!--                <b-card-text>答案</b-card-text>-->
<!--                <MyTagInput v-model="masterItem.Tags"  placeholder="請輸入"></MyTagInput>-->
                <MyCkEditor v-model="masterItem.HtmlContent" height="600px" width="1000px"></MyCkEditor>
                <!--            :options="tags"-->

                <!--                <b-button v-b-toggle.collapse-1-inner size="sm">輔助說明</b-button>-->
                <!--                <b-collapse id="collapse-1-inner" class="mt-2">-->
                <!--                  <b-card>xxxxxxxx</b-card>-->
                <!--                </b-collapse>-->
              </b-card>
            </b-collapse>
          </td>
        </tr>
      </template>

      </tbody>
    </table>

<!--    <DLGEditor ref="dlgEditor" v-on:returnOk="dlgEditorReturnOK" />-->
  </div>
</template>

<script>
/**

 **/

import arrayUtil from "../../util/arrayUtil";
import util from "../../util/util";
import MyButtonEnableDisable from "@/views/taylorAdmin/component/MyButtonEnableDisable";
import _ from "lodash";
import MyTagInput from "@/views/taylorAdmin/component/MyTagInput";
// import MyCkEditor from "@/views/taylorAdmin/component/MyCkEditor";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";
import MyCkEditor from "@/views/taylorAdmin/component/MyCkEditor";

export default {
  components: {MyCkEditor, MyTagInput,   MyButtonEnableDisable},
  //name: "contentEdit",
  // props: [""],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      isEnableFilter: true,
      currentFilterGroup1:"init", //給允預設值，先不顯示任何項目
      currentFilterGroup2:"",
      datas:{
        KBItems: []
      },
      datasDemo:{
        KBItems: [
          {
            SystemId: "",
            OrderKey: "",
            IsEnable:true,
            Group1: "",
            Tags:[],
            Text: "",
            HtmlContent:"",
          },
        ]
      },
    };
  },
  methods: {
    loadData() {
      let that=this;
      let loader=util.ShowLoading(this);
      apiAdmin.api_getContent(this.$u.TzsciQueryType_KB).then((data)=>{
        let dataApi=apiAdmin.init(data.data.data);

        that.datas=dataApi;
        util.HideLoading(loader);
        // that.$nextTick(() => { //with this we skip the first change
        //   that.isLoaded = true
        // })
      })
    },
    gotoHelpMemoEdit(item){
      this.$router.push({
        path: "/AppContentHelpMemoEdit",
        // path: item.url,
      });
    },
    submit(){
      apiAdmin.api_saveContent(this.$u.TzsciQueryType_KB,this.datas).then((data)=>{
        alert('儲存成功')
      })
    },

    DataItemMaster_MoveUp(item) {
      arrayUtil.orderMove(false, item.SystemId, this.datas.KBItems, "SystemId", "OrderKey")
    },
    DataItemMaster_MoveDown(item) {
      arrayUtil.orderMove(true, item.SystemId, this.datas.KBItems, "SystemId", "OrderKey")
    },
    DataItemMaster_AddLast() {
      let newItem = {
        SystemId: "",
        OrderKey: "",
        IsEnable:true,
        Group1: "",
        Tags:[],
        Text: "",
        HtmlContent:"",
      };
      newItem.SystemId = util.uuid();

      arrayUtil.orderAppendLast(newItem, this.datas.KBItems, "OrderKey")
    },
    DataItemMaster_Insert(currentItem){
      let newItem =          {
            SystemId: "",
            OrderKey: "",
            IsEnable:true,
            Group1: "",
            Tags:[],
            Text: "",
            HtmlContent:"",
          };
      newItem.SystemId = util.uuid();

      arrayUtil.orderInsert(newItem,currentItem,this.datas.KBItems,"SystemId","OrderKey")
    },
    DataItemMaster_Remove(item) {
      arrayUtil.removeByPredicate(this.datas.KBItems,s => s.SystemId===item.SystemId);
    },
    btnEnableOrDisable(){
      this.isEnableFilter=!this.isEnableFilter;
      if (this.isEnableFilter){
        console.log("");
      }else{
        this.currentFilterGroup1="";
        this.currentFilterGroup2="";
      }
    },
    btnClear(){
      this.currentFilterGroup1="";
      this.currentFilterGroup2="";
    },
    FilterByGroup1(group1){
      // if (this.datas.KBItems.length===0){
      //   this.loadData();
      // }
      this.currentFilterGroup1=group1;
      this.currentFilterGroup2="";
    },
    GetUniqueGroup1(){
      let group1s = this.datas.KBItems.map(s=>s.Group1);
      return _.filter(arrayUtil.removeDupicate(group1s), Boolean);
    },
    IsShow(kb){

      if (this.currentFilterGroup1 ==="" ){
        return true;//沒有啟用篩選
      }

      if (this.currentFilterGroup1 !==""){
        if (kb.Group1===this.currentFilterGroup1) {
          return true;//篩選group2
        }
      }else{
        return false;
      }


    },
    // editHtmlContent(item){
    //   this.$refs.dlgEditor.callbackItem=item;
    //   this.$refs.dlgEditor.htmlContent=item.HtmlContent;
    //   this.$refs.dlgEditor.showModal();
    // },
    // dlgEditorReturnOK(item){
    //   item.HtmlContent=this.$refs.dlgEditor.htmlContent;
    // }
  },
  mounted() {
    this.loadData()
  },
}
</script>


<style scoped>
#tblMain{
  width: 1300px;
}
.thisBtnEdit{
  color: white !important;
  margin: 5px;
  width: 40px;
}
.filterItembutton{
  color: white !important;
  width: 220px;
}
.abutton{
  color: white !important;
}
.btn{
  color: white !important;
  margin: 5px;
}
</style>
